// Messages for operator/settings/Carriers (auto-merged into the i18n catalog).
export const en = {
  'operator.carriers.head': 'Carriers — Operator',
  'operator.carriers.title': 'Carriers',
  'operator.carriers.subtitle': 'Shipping lines / airlines & their transport modes',
  'operator.carriers.add': 'Add carrier',
  'operator.carriers.col.name': 'Name',
  'operator.carriers.col.modes': 'Modes',
  'operator.carriers.col.contact': 'Contact',
  'operator.carriers.col.shipments': 'Shipments',
  'operator.carriers.empty': 'No carriers found.',
  'operator.carriers.shipments': '{count} shipments',
  'operator.carriers.mode.ship': 'Ocean',
  'operator.carriers.mode.air': 'Air',
  'operator.carriers.mode.truck': 'Truck',
  'operator.carriers.mode.train': 'Rail',
}

export const zhTW = {
  'operator.carriers.head': '承運商 — 操作端',
  'operator.carriers.title': '承運商',
  'operator.carriers.subtitle': '船公司／航空公司及其運輸模式',
  'operator.carriers.add': '新增承運商',
  'operator.carriers.col.name': '名稱',
  'operator.carriers.col.modes': '模式',
  'operator.carriers.col.contact': '聯絡人',
  'operator.carriers.col.shipments': '貨件',
  'operator.carriers.empty': '找不到承運商。',
  'operator.carriers.shipments': '{count} 件貨件',
  'operator.carriers.mode.ship': '海運',
  'operator.carriers.mode.air': '空運',
  'operator.carriers.mode.truck': '卡車',
  'operator.carriers.mode.train': '鐵路',
}
